import { axios } from '@util';

class FilesService {
	/**
	 * Uploads an item to the collection of exports.
	 *
	 * @returns Promise
	 */
	async uploadFile(formData) {
		const rs = await axios({
			url: `/file/upload/`,
			method: 'POST',
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			data: formData,
		});

		return rs;
	}
}

export default new FilesService();
